"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var pickers_1 = require("@material-ui/pickers");
var core_1 = require("@21st-night/core");
var core_2 = require("@material-ui/core");
var ui_1 = require("@21st-night/ui");
var dayjs_1 = __importDefault(require("dayjs"));
var Button_1 = __importDefault(require("../../Button"));
function getKeys(obj, prefix) {
    if (prefix === void 0) { prefix = ''; }
    if (typeof obj === 'undefined' || obj === null)
        return [];
    return __spreadArray(__spreadArray([], __read(Object.keys(obj).map(function (key) { return "" + prefix + key; }))), __read(Object.entries(obj).reduce(function (acc, _a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        if (typeof value === 'object')
            return __spreadArray(__spreadArray([], __read(acc)), __read(getKeys(value, "" + prefix + key + ".")));
        return acc;
    }, [])));
}
function flatObject(obj, prefix) {
    if (prefix === void 0) { prefix = ''; }
    if (typeof obj === 'undefined' || obj === null)
        return {};
    return Object.entries(obj).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (typeof value === 'object')
            return __assign(__assign({}, acc), flatObject(value, "" + prefix + key + "."));
        return __assign(__assign({}, acc), (_b = {}, _b["" + prefix + key] = value, _b));
    }, {});
}
function escapeCsvValue(cell) {
    if (cell.replace(/ /g, '').match(/[\s,"]/)) {
        return "\"" + cell.replace(/"/g, '""') + "\"";
    }
    return cell;
}
function objectsToCsv(arrayOfObjects) {
    // collect all available keys
    var keys = new Set(arrayOfObjects.reduce(function (acc, item) { return __spreadArray(__spreadArray([], __read(acc)), __read(getKeys(item))); }, []));
    // for each object create all keys
    var values = arrayOfObjects.map(function (item) {
        var fo = flatObject(item);
        var val = Array.from(keys).map(function (key) {
            return key in fo ? escapeCsvValue("" + fo[key]) : '';
        });
        return val.join(',');
    });
    return Array.from(keys).join(',') + "\n" + values.join('\n');
}
exports.useStyles = styles_1.makeStyles(function () {
    return styles_1.createStyles({
        root: {},
        listItemIcon: {
            minWidth: 64,
        },
    });
});
var StudyPlanAddToCalendar = function (_a) {
    var classNameProp = _a.className, items = _a.items, other = __rest(_a, ["className", "items"]);
    var classes = exports.useStyles();
    var _b = __read(react_1.useState(false), 2), open = _b[0], setOpen = _b[1];
    var _c = __read(react_1.useState('ics'), 2), fileType = _c[0], setFileType = _c[1];
    var eventTime = new Date();
    eventTime.setHours(20, 0, 0, 0);
    var _d = __read(react_1.useState(dayjs_1.default(eventTime)), 2), selectedTime = _d[0], handleTimeChange = _d[1];
    var time = selectedTime || dayjs_1.default(eventTime);
    var createFile = react_1.useCallback(function (content, type, extension) {
        var blob = new Blob(content, { type: type });
        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(blob, "Study_Plan." + extension);
        }
        else {
            var elem = window.document.createElement('a');
            elem.href = window.URL.createObjectURL(blob);
            elem.download = "Study_Plan." + extension;
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);
        }
        setOpen(false);
    }, []);
    var generateIcsFile = react_1.useCallback(function () {
        var calendar = [
            'BEGIN:VCALENDAR',
            'VERSION:2.0',
            'PRODID:Calendar',
            'CALSCALE:GREGORIAN',
            'X-WR-CALNAME:21st Night Study Plan',
        ];
        items.forEach(function (item) {
            calendar.push('BEGIN:VEVENT');
            calendar.push("UID:" + item.id.toUpperCase());
            calendar.push("CLASS:PUBLIC");
            calendar.push("SUMMARY;LANGUAGE=en-us:" + core_1.convertToPlainText(JSON.parse(item.title)));
            calendar.push("DTSTAMP;VALUE=DATE-TIME:" + dayjs_1.default(item.date).format('YYYYMMDD') + "T" + time.format('HHmm') + "00");
            calendar.push("DTSTART;VALUE=DATE-TIME:" + dayjs_1.default(item.date).format('YYYYMMDD'));
            calendar.push("DTEND;VALUE=DATE-TIME:" + dayjs_1.default(item.date).format('YYYYMMDD'));
            calendar.push('TRANSP:TRANSPARENT');
            calendar.push('END:VEVENT');
        });
        calendar.push('END:VCALENDAR');
        createFile(calendar.map(function (row) { return row + "\r\n"; }), 'text/calendar', 'ics');
    }, [createFile, items, time]);
    var generateCsvFile = react_1.useCallback(function () {
        var csv = objectsToCsv(items.map(function (item) { return ({
            Subject: core_1.convertToPlainText(JSON.parse(item.title)),
            'Start date': dayjs_1.default(item.date).format('MM/DD/YYYY'),
            'Start time': "" + time.format('HH:mm'),
        }); }));
        createFile([csv], 'text/csv', 'csv');
    }, [createFile, items, time]);
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(Button_1.default, __assign({ color: "primary", variant: "outlined", size: "large", onClick: function () { return setOpen(true); }, className: clsx_1.default(classes.root, classNameProp) }, other), "Add to Calendar"),
        react_1.default.createElement(core_2.Dialog, { fullWidth: true, maxWidth: "sm", open: open },
            react_1.default.createElement(core_2.DialogTitle, null, "Add to Calendar"),
            react_1.default.createElement(core_2.DialogContent, null,
                react_1.default.createElement(core_2.Typography, { variant: "h6" }, "Event time"),
                react_1.default.createElement(core_2.Typography, { color: "textSecondary", paragraph: true }, "At what time should the events appear in the calendar?"),
                react_1.default.createElement(pickers_1.TimePicker, { renderInput: function (props) { return (react_1.default.createElement(ui_1.TextField, __assign({}, props, { helperText: "", placeholder: "08:00 PM" }))); }, value: selectedTime, onChange: function (date) { return handleTimeChange(date); } }),
                react_1.default.createElement(core_2.Typography, { variant: "h6", style: { marginTop: 32 } }, "Format"),
                react_1.default.createElement(core_2.RadioGroup, { name: "file-type", value: fileType, onChange: function (event, value) { return setFileType(value); } },
                    react_1.default.createElement(core_2.List, null,
                        react_1.default.createElement(core_2.ListItem, { button: true, divider: true, onClick: function () { return setFileType('ics'); } },
                            react_1.default.createElement(core_2.ListItemIcon, null,
                                react_1.default.createElement(core_2.Radio, { value: "ics" })),
                            react_1.default.createElement(core_2.ListItemText, { primary: "ICS", secondary: "For Apple Calendar, Google Calendar, Outlook Calendar, Yahoo Calendar" })),
                        react_1.default.createElement(core_2.ListItem, { button: true, onClick: function () { return setFileType('csv'); } },
                            react_1.default.createElement(core_2.ListItemIcon, null,
                                react_1.default.createElement(core_2.Radio, { value: "csv" })),
                            react_1.default.createElement(core_2.ListItemText, { primary: "CSV", secondary: "For calendars which do not support ICS files" }))))),
            react_1.default.createElement(core_2.DialogActions, null,
                react_1.default.createElement(Button_1.default, { onClick: function () { return setOpen(false); } }, "Cancel"),
                react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", onClick: fileType === 'ics' ? generateIcsFile : generateCsvFile }, "Download")))));
};
exports.default = StudyPlanAddToCalendar;
//# sourceMappingURL=StudyPlanAddToCalendar.js.map